/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Gmail_Read_SuccessInputs */

const es_tools_gmail_read_success = /** @type {(inputs: Tools_Gmail_Read_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo de Gmail leído`)
};

const en_tools_gmail_read_success = /** @type {(inputs: Tools_Gmail_Read_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gmail message read`)
};

/**
* | output |
* | --- |
* | "Gmail message read" |
*
* @param {Tools_Gmail_Read_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_gmail_read_success = /** @type {((inputs?: Tools_Gmail_Read_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Gmail_Read_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_gmail_read_success(inputs)
	return en_tools_gmail_read_success(inputs)
});
export { tools_gmail_read_success as "tools.gmail.read_success" }